import { Component } from '@angular/core';

@Component({
  selector: 'title-component',
  templateUrl: 'title.component.html'
})
export class TitleComponent {}
